import { render, staticRenderFns } from "./TradesSummary.vue?vue&type=template&id=11d7b245&"
import script from "./TradesSummary.vue?vue&type=script&lang=js&"
export * from "./TradesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports